import { render, staticRenderFns } from "./RoutePlanAlternates.vue?vue&type=template&id=5550b14a&scoped=true"
import script from "./RoutePlanAlternates.vue?vue&type=script&lang=js"
export * from "./RoutePlanAlternates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5550b14a",
  null
  
)

export default component.exports